import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box
} from '@mui/material';

const renderValue = (value) => {
  if (value === null || typeof value === 'undefined') {
    return <Typography variant="caption" color="text.secondary">няма</Typography>;
  }
  if (typeof value === 'object') {
    return <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{JSON.stringify(value, null, 2)}</pre>;
  }
  return String(value);
};

const AuditLogChangesTable = ({ changedFields }) => {
  if (!changedFields || Object.keys(changedFields).length === 0) {
    return <Typography variant="body2">Няма проследени промени по полетата.</Typography>;
  }

  // Filter out the lastUpdatedAt field
  const filteredFields = Object.fromEntries(
    Object.entries(changedFields).filter(([field]) => field !== 'lastUpdatedAt')
  );

  // If no fields are left after filtering, show a message
  if (Object.keys(filteredFields).length === 0) {
    return <Typography variant="body2" color="text.secondary" sx={{mt: 2}}>Промените засягат само автоматично обновени полета (като дата на промяна) и не се показват.</Typography>;
  }

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Детайли на промените
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small" aria-label="детайли на промените">
          <TableHead sx={{ bgcolor: 'grey.100' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Поле</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Стара стойност</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Нова стойност</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(filteredFields).map(([field, values]) => (
              <TableRow key={field} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  <Typography variant="body2" sx={{ fontWeight: 'medium' }}>{field}</Typography>
                </TableCell>
                <TableCell sx={{ color: '#ef4444', backgroundColor: 'rgba(239, 68, 68, 0.05)' }}>
                  {renderValue(values.oldValue)}
                </TableCell>
                <TableCell sx={{ color: '#10b981', backgroundColor: 'rgba(16, 185, 129, 0.05)' }}>
                  {renderValue(values.newValue)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AuditLogChangesTable;
